<template>
  <div>
    <application-code-add-new
        :is-add-new-application-code-sidebar-active.sync="isAddNewApplicationCodeSidebarActive"
        :id = "id"
        :data="applicationcodeData"
        @refetch-data="refetchData"
        v-if="ability.can('create','applicationcodes')"
    >

    </application-code-add-new>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap">Add Application Code</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refApplicationCodeListTable"
        class="position-relative"
        :items="fetchApplicationCodes"
        responsive
        stacked="md"
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(is_active)="data">
        <feather-icon 
        v-if="data.item.is_active"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>
    <template #cell(action)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','applicationcodes')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalApplicationCodes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import applicationcodeStoreModule from "../applicationcodeStoreModule";
import useApplicationCodesList from "./useApplicationCodesList";
import ApplicationCodeAddNew from "./ApplicationCodeListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ApplicationCodeAddNew,
  },
  methods:{
      handleCreate(){
          this.id = 0
          this.resetApplicationCodeData()
          this.isAddNewApplicationCodeSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.applicationcodeData.id = item.id
        this.applicationcodeData.code_name = item.code_name
        this.applicationcodeData.is_active = item.is_active
        this.isAddNewApplicationCodeSidebarActive = true
        
      }, resetApplicationCodeData(){
        this.applicationcodeData = {
            id: 0,
            code_name: '',
            is_active:true,

        }
      }
  },
  data(){
    return {
        id:0,
        applicationcodeData:{},
    }  
  },
  setup() {
    const SETTING_APPLICATION_CODE_STORE_MODULE_NAME = "setting-applicationcode";

    if (!store.hasModule(SETTING_APPLICATION_CODE_STORE_MODULE_NAME))
      store.registerModule(
        SETTING_APPLICATION_CODE_STORE_MODULE_NAME,
        applicationcodeStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(SETTING_APPLICATION_CODE_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_APPLICATION_CODE_STORE_MODULE_NAME);
    });

    const isAddNewApplicationCodeSidebarActive = ref(false);

    const {
      fetchApplicationCodes,
      tableColumns,
      perPage,
      currentPage,
      totalApplicationCodes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refApplicationCodeListTable,
      refetchData,
      ability,
    } = useApplicationCodesList();

    return {
      //Sidebar
      isAddNewApplicationCodeSidebarActive,

      fetchApplicationCodes,
      tableColumns,
      perPage,
      currentPage,
      totalApplicationCodes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refApplicationCodeListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>